import { observable, computed, action } from 'mobx';
import { API_URL } from '../constants/constants';
import { CompanyStore } from './CompanyStore';
import { NotificationStore } from './NotificationStore';
import { ReactNode } from 'react';

class ModalStore {
  @observable
  public isOpen: boolean;

  @observable
  public title: ReactNode;

  @observable
  public errors: Array<string>;

  @observable
  public children: ReactNode;

  @observable
  public onlyCloseButton: boolean;

  @observable
  public size: string;

  @observable
  public trigger: string;

  @observable
  public data: string;

  constructor() {
    this.isOpen = false;
    this.title = '';
    this.errors = [];
    this.children = undefined;
    this.onlyCloseButton = false;
    this.size = '';
    this.data = '';
  }

  @computed
  get isModalOpen() {
    return this.isOpen;
  }

  @computed
  get modalTitle() {
    return this.title;
  }

  @computed
  get modalErrors() {
    return this.errors;
  }

  @computed
  get modalChildren() {
    return this.children;
  }

  @computed
  get modalOnlyCloseButton() {
    return this.onlyCloseButton;
  }

  @computed
  get modalSize() {
    return this.size;
  }

  @computed
  get modalTrigger() {
    return this.trigger;
  }

  @action
  setTrigger(trigger: string) {
    this.trigger = trigger;
  }

  @action
  setSize(size: string) {
    this.size = size;
  }

  @action
  setChildren(children: ReactNode) {
    this.children = children;
  }

  @action
  toggleModal() {
    this.isOpen = !this.isOpen;
  }

  @action
  openModal() {
    this.isOpen = true;
  }

  @action
  closeModal() {
    this.isOpen = false;
  }

  @action
  setTitle(title: ReactNode) {
    this.title = title;
  }

  @action
  addError(error: string) {
    this.errors = [...this.errors, error];
  }

  @action
  clearErrors() {
    this.errors = [];
  }

  @action
  clearStore() {
    this.errors = [];
    this.title = '';
    this.children = undefined;
    this.onlyCloseButton = false;
    this.size = '';
    this.trigger = '';
    this.data = '';
  }

}

export default ModalStore;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/ModalStore.ts